
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ProductsSection from './components/ProductsSection';
import ServicesSection from './components/ServicesSection';
import OrderSection from './components/OrderSection';
import ContactSection from './components/ContactSection';

export default function Home() {
  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: '"Inter", sans-serif' }}>
      <Header />
      <main>
        <HeroSection />
        <ProductsSection />
        <ServicesSection />
        <OrderSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
